(function () {
  'use strict';

  angular.module('app.login', []);

})();